// extracted by mini-css-extract-plugin
export var modal = "_fd-0";